import { ArrowLeftIcon } from '@/assets/images';
import PropTypes from 'prop-types';
import './ListTile.scss';

const ListTile = ({
   avatar,
   title,
   subTitle,
   trailing,
   showBack = false,
   onBack = () => {},
   onClick = () => {},
   className = '',
   dotStatus = '', // 'online', 'read', 'delivered'
   as: Component = 'button',
   titleAlign = 'left',
   isTrailingClickable = true,
   contentClassName = '',
   ...rest
}) => {
   const containerClasses = [
      'chat-item',
      'ct-flex',
      'ct-aiCenter',
      'ct-gap14',
      'ct-cursor',
      'ct-wFull',
      dotStatus ? `dot-${dotStatus}` : '',
      className,
   ]
      .filter(Boolean)
      .join(' ');

   return (
      <Component className={containerClasses} onClick={onClick} {...rest}>
         {showBack && (
            <button
               className="chat-back-arrow ct-flexCenter ct-cursor"
               aria-label="Back"
               onClick={e => {
                  e.stopPropagation();
                  onBack();
               }}
            >
               <ArrowLeftIcon className="chat-back-icon" />
            </button>
         )}

         {avatar && <div className="chat-avatar-wrapper ct-relative ct-flexCenter">{avatar}</div>}

         <div className={`ct-flex ct-jcBetween ct-aiCenter ct-flex1 ct-gap12 ${contentClassName}`}>
            <div className={`chat-left ct-flex ct-fcol ct-gap4 ct-flex1 ${titleAlign}`}>
               <div className="chat-name">{title}</div>
               {subTitle && <div className="ct-flex ct-aiCenter ct-gap4">{subTitle}</div>}
            </div>

            {trailing && (
               <div
                  className="chat-right ct-flex ct-fcol ct-gap4 ct-aiEnd"
                  onClick={!isTrailingClickable ? e => e.stopPropagation() : undefined}
                  onKeyDown={
                     !isTrailingClickable
                        ? e => {
                             if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
                          }
                        : undefined
                  }
               >
                  {trailing}
               </div>
            )}
         </div>
      </Component>
   );
};

ListTile.propTypes = {
   avatar: PropTypes.node,
   title: PropTypes.node,
   subTitle: PropTypes.node,
   trailing: PropTypes.node,
   showBack: PropTypes.bool,
   onBack: PropTypes.func,
   onClick: PropTypes.func,
   className: PropTypes.string,
   dotStatus: PropTypes.string,
   as: PropTypes.elementType,
   titleAlign: PropTypes.oneOf(['left', 'center', 'right']),
   isTrailingClickable: PropTypes.bool,
   contentClassName: PropTypes.string,
};

export default ListTile;
